import { render } from "./AboutBlock.vue?vue&type=template&id=5f44a520&scoped=true"
import script from "./AboutBlock.vue?vue&type=script&lang=js"
export * from "./AboutBlock.vue?vue&type=script&lang=js"

import "./AboutBlock.vue?vue&type=style&index=0&id=5f44a520&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f44a520"]])

export default __exports__